import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { grantAnalyticsConsent, initAnalytics } from './utils/analytics';

// Boot GA4 / GTM (no-op when neither REACT_APP_GA4_MEASUREMENT_ID nor
// REACT_APP_GTM_CONTAINER_ID is set). Consent default is already
// `denied` from the inline script in public/index.html.
initAnalytics();

// Temporary opt-in escape hatch until the consent banner ships.
// Setting `REACT_APP_ANALYTICS_AUTO_GRANT=true` flips analytics_storage
// to `granted` immediately so data starts flowing — useful for
// validating measurement during development / soft-launch. Remove this
// flag once the proper consent UI lands (§8.4 of the GA4 guideline).
if (process.env.REACT_APP_ANALYTICS_AUTO_GRANT === 'true') {
  grantAnalyticsConsent();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Safety net for i18next namespace loading. `useSuspense` is on by default, so
// a component reaching for a namespace that wasn't preloaded (see the `ns` list
// in src/i18n/config.ts) suspends. Without a boundary React tears the whole tree
// down with "A component suspended while responding to synchronous input";
// with one it briefly shows this fallback instead.
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <React.Suspense fallback={<div className="min-h-screen bg-white" />}>
        <App />
      </React.Suspense>
    </HelmetProvider>
  </React.StrictMode>
);
